import React from 'react';
import { OfferBox } from './OfferBox';
export function PricingSection() {
  return <section id="precio" className="w-full scroll-mt-4 bg-ink-900 px-4 py-11 text-cream sm:px-8 sm:py-16 lg:py-20" data-id="element-123" data-mp="19iw0h5aqqes1">
      <div className="mx-auto max-w-3xl text-center" data-id="element-124" data-mp="1ehgqkbwa3i2r">
        <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.16em] text-gold-400 sm:text-sm sm:tracking-[0.18em]" data-id="element-125" data-mp="1j8ysp3a1fopb">
          Al comprar el Mega Pack recibís
        </p>
        <h2 className="mt-2 font-display text-2xl font-extrabold leading-tight sm:mt-3 sm:text-4xl" data-id="element-126" data-mp="1ncwpv8fsypfq">
          12 recursos educativos en un solo Mega Pack
        </h2>
        <p className="mx-auto mt-3 max-w-2xl font-sans text-sm leading-relaxed text-cream-200 sm:mt-4 sm:text-lg" data-id="element-127" data-mp="1x99ie2zm2x8w">
          Una biblioteca que vas a reutilizar durante todo el ciclo lectivo, por
          un único pago.
        </p>

        <OfferBox className="mt-6 sm:mt-8" data-id="element-128" data-mp="2x1rd0qev0ie" />
      </div>
    </section>;
}